// component
import Iconify from './Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfig = [
    {
      title: 'Dashboard',
      path: '/admin/dashboard',
      icon: getIcon('eva:pie-chart-2-fill'),
    },
    {
      title: 'Approval',
      path: '/admin/approval',
      icon: getIcon('eva:file-text-fill'),
    },
    {
      title: 'Cancellations',
      path: '/admin/cancellations',
      icon: getIcon('eva:close-circle-fill'),
    },
    {
      title: 'Refunds',
      path: '/admin/refunds',
      icon: getIcon('eva:credit-card-fill'),
    },
    {
      title: 'Ledger',
      path: '/admin/ledger',
      icon: getIcon('fa:book'),
    },
    {
      title: 'Users',
      path: '/admin/manage-users',
      icon: getIcon('eva:people-fill'),
      
    },
    {
      title: 'Manage Courts',
      path: '/admin/manage-court',
      icon: getIcon('eva:shopping-bag-fill'),
    },
  ];
  
  export default navConfig;